import React from 'react';
import { FormField, IFormField } from './FormField';
import { TreeSelect } from 'primereact/treeselect';
import { PrimeReactProvider } from 'primereact/api';
import Tailwind from 'primereact/passthrough/tailwind';
import classNames from 'classnames';
import { TreeNode } from 'primereact/treenode';

Tailwind.treeselect = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  root: ({ props }: { props: any }) => ({
    className: classNames(
      'inline-flex cursor-pointer select-none',
      'bg-white border border-[#c4c4c480] transition-colors duration-200 ease-in-out rounded-md',
      'w-full h-11',
      {
        'opacity-60 select-none pointer-events-none cursor-default':
        props?.disabled,
      },
    ),
  }),
  labelContainer: {
    className: classNames('overflow-hidden flex flex-auto cursor-pointer'),
  },
  label: {
    className: classNames(
      'block overflow-hidden whitespace-nowrap cursor-pointer overflow-ellipsis',
      'text-gray-800',
      'p-3 transition duration-200',
    ),
  },
  trigger: {
    className: classNames(
      'flex items-center justify-center shrink-0',
      'bg-transparent text-gray-600 w-12 drounded-tr-lg rounded-br-lg',
    ),
  },
  panel: {
    className: classNames(
      'bg-white text-gray-700 border-0 rounded-md shadow-lg',
    ),
  },
  wrapper: {
    className: classNames(
      'max-h-[200px] overflow-auto',
      'bg-white text-gray-700 border-0 rounded-md shadow-lg',
    ),
  },
  closeButton: {
    className: classNames('hidden'),
  },
  filterIcon: {
    className: classNames('hidden'),
  },
  filter: {
    className: classNames('p-2 w-full border border-gray-500 rounded-md focus:outline-blue-600'),
  },
};

interface SelectFieldProps extends IFormField {
  options?: TreeNode[];
  filter?: boolean;
}

export type ISelectOption = { value: string; label: string };

export const SelectTreeField: React.FC<SelectFieldProps> = props => {
  return (
    <FormField
      {...props}
      render={({ field }) => {
        return (
          <PrimeReactProvider value={{ unstyled: true, pt: Tailwind }}>
            <TreeSelect
              name={field.name}
              options={props.options}
              className="w-full md:w-20rem"
              placeholder="Select..."
              value={field.value}
              onChange={e => field.onChange(e.value)}
              filter={props.filter ?? false}
              filterInputAutoFocus
              resetFilterOnHide
              disabled={props.disabled}
            ></TreeSelect>
          </PrimeReactProvider>
        );
      }}
    />
  );
};
